(function () {

    $('.sd_pro-search').click(function () {
        $value = $(".sd_pro-search").val();
        if ($value == "") {
            $('.sd_dropdown').show();
            $('.sd_dropdown').html('');
        }
        else {
            $('.sd_dropdown').show();
        }

    });

    $(document).on('mouseup', 'body', function (e) {
        var container = $(".sd_product-search");
        var submit = $(".searchBar__submit");
        var icon = $(".fa-search");
        // If the target of the click isn't the container

        if (!container.is(e.target) && container.has(e.target).length === 0 && (!submit.is(e.target)) && (!icon.is(e.target))) {
            $('.sd_dropdown').hide();
            $('.sd_pro-search').val('');
        }
    });

    // console.log($(window).width());
    $("<div class='sd_fixsearch' style='font-family: arial;border-radius: 2px 0 0 2px;box-sizing: border-box;height: 38px;max-width: 400px;position:fixed;top: 150px;z-index: 9999999999;width: 100%;transition: all 0.6s ease-in 0s;visibility:hidden;opacity:0;'><div class='sd_fixinner' style='font-family: arial;'><img src='https://storage.googleapis.com/binderpos-libraries/white-search.png' class='sd_searchicon' style='font-family: arial;cursor:pointer;background:#494c50 none repeat scroll 0 0;width: 38px; border-radius: 5px 0 0 5px;padding: 5px;float: left;'><div class='sd_product-search' style='float: left;height: 38px;position: relative;transition: all 0.5s ease 0s;max-width: auto;margin-top:0;'><input type='text' class='sd_pro-search' style='background:white!important;height: 38px!important;width:90%!important;padding: 5px!important;z-index:9999999999;'><div class='sd_dropdown'></div></div></div></div><input type='hidden' class='fullval'>").insertAfter("body");
    if ($(window).width() < 767) {
        $('.sd_fixinner .sd_product-search').css({ 'margin': '0', 'max-width': '100%', 'font-family': 'arial', 'height': '38px', 'width': '88%', 'position': 'relative' });
        $('.sd_fixsearch').css({ 'right': '-362px' });
    }
    else {
        $('.sd_fixinner .sd_product-search').css({ 'margin': '0', 'max-width': '100%', 'font-family': 'arial', 'height': '38px', 'width': '90%', 'position': 'relative' });
        $('.sd_fixsearch').css({ 'right': '-362px' });
    }
    var sizeee = "-362px";
    if ($(window).width() == 375) {
        $('.sd_fixsearch').css({ 'right': '-337px' });
        var sizeee = "-337px";
    }

    if ($(window).width() == 360) {
        $('.sd_fixsearch').css({ 'right': '-322px' });
        var sizeee = "-322px";
    }
    if ($(window).width() == 320) {
        $('.sd_fixsearch').css({ 'right': '-282px' });
        var sizeee = "-282px";
    }


    var searchtext = null
    var prccolor = null

    function highlight(string) {
        $(".sd_dropdownresult li, .sd_dropdown_default li").each(function () {
            var matchStart = $(this).find('.sd_title').text().toLowerCase().indexOf("" + string.toLowerCase() + "");
            var matchEnd = matchStart + string.length - 1;
            var beforeMatch = $(this).find('.sd_title').text().slice(0, matchStart);
            var matchText = $(this).find('.sd_title').text().slice(matchStart, matchEnd + 1);
            var afterMatch = $(this).find('.sd_title').text().slice(matchEnd + 1);
            var finalMatch = beforeMatch + "<span style='color:" + searchtext + "!important; font-weight:700!important;'>" + matchText + "</span>" + afterMatch;
            $(this).find('.sd_title').html(finalMatch);
        });
    }

    function highlight_variant(string) {
        $(".sd_dropdownresult li, .sd_dropdown_default li").each(function () {
            var matchStart = $(this).find('.sd_sku').text().toLowerCase().indexOf("" + string.toLowerCase() + "");
            var matchEnd = matchStart + string.length - 1;
            var beforeMatch = $(this).find('.sd_sku').text().slice(0, matchStart);
            var matchText = $(this).find('.sd_sku').text().slice(matchStart, matchEnd + 1);
            var afterMatch = $(this).find('.sd_sku').text().slice(matchEnd + 1);
            var finalMatch = beforeMatch + "<span style='color:" + searchtext + "!important; font-weight:700!important;'>" + matchText + "</span>" + afterMatch;
            $(this).find('.sd_titl').html(finalMatch);
        });
    }


    function col_highlight(string) {
        $(".sd_dropdownresult_collection li, .sd_dropdown_default li").each(function () {
            var matchStart = $(this).find('.sd_title').text().toLowerCase().indexOf("" + string.toLowerCase() + "");
            var matchEnd = matchStart + string.length - 1;
            var beforeMatch = $(this).find('.sd_title').text().slice(0, matchStart);
            var matchText = $(this).find('.sd_title').text().slice(matchStart, matchEnd + 1);
            var afterMatch = $(this).find('.sd_title').text().slice(matchEnd + 1);
            var finalMatch = beforeMatch + "<span style='color:" + searchtext + "!important; font-weight:700!important;'>" + matchText + "</span>" + afterMatch;
            $(this).find('.sd_title').html(finalMatch);
        });
    }

    function page_highlight(string) {
        $(".sd_dropdownresult_page li, .sd_dropdown_default li").each(function () {
            var matchStart = $(this).find('.sd_title').text().toLowerCase().indexOf("" + string.toLowerCase() + "");
            var matchEnd = matchStart + string.length - 1;
            var beforeMatch = $(this).find('.sd_title').text().slice(0, matchStart);
            var matchText = $(this).find('.sd_title').text().slice(matchStart, matchEnd + 1);
            var afterMatch = $(this).find('.sd_title').text().slice(matchEnd + 1);
            var finalMatch = beforeMatch + "<span style='color:" + searchtext + "!important; font-weight:700!important;'>" + matchText + "</span>" + afterMatch;
            $(this).find('.sd_title').html(finalMatch);
        });
    }

    $(document).on("click", ".sd_searchicon", function () {
        $('.sd_fixsearch').toggleClass('sd_fixactive');
        if ($('.sd_fixsearch').hasClass('sd_fixactive')) {
            $('.sd_fixsearch').css('right', '-2px');
            $(document).on("click", "body", function () {
                $('.sd_fixsearch').css({ 'right': sizeee });
                $('.sd_fixsearch').removeClass('sd_fixactive');
                $('.sd_pro-search').val('');
                $('.sd_dropdown').empty();
            });
        } else {
            $('.sd_fixsearch').css({ 'right': sizeee });
            $('.sd_pro-search').val('');
            $('.sd_dropdown').empty();
        }
    });

    $('.sd_product-search').css('display', 'none');
    $('.sd_pro-search').attr("placeholder", "Search..");


    /* Default search starts here */
    var resvalue = { "defaultwidth": null, "product_tab": null, "collection_tab": null, "page_tab": null, "article_tab": null, "stock_res": null, "foot_text": null, "footer_noresult": null };
    var defull = $.trim(resvalue.defaultwidth);
    var product = window.theme.searchMode.includes("product") ? "yes" : "no";
    var collection = 'no';
    var page = window.theme.searchMode.includes("page") ? "yes" : "no";
    var article = window.theme.searchMode.includes("article") ? "yes" : "no";
    var footer_text = $.trim(resvalue.foot_text);
    var footer_noresult = $.trim(resvalue.footer_noresult);
    if (footer_noresult == '' || footer_noresult == null) {
        var footer_noresult = "No Results Found";
    }
    else {
        var footer_noresult = footer_noresult;

    }

    if (footer_text == '' || footer_text == null) {
        var footer_boxtext = "Show More Results";
    }
    else {
        var footer_boxtext = footer_text;

    }

    if (resvalue.stock_res != null) {
        var out_stock = $.trim(resvalue.stock_res);
    }
    else {
        var out_stock = "last";
    }

    $(function () {
        $('.sd_product-search').css({ 'position': 'relative', 'max-width': '280px', });
        $('.sd_dropdown').css({ 'position': 'absolute', 'width': '100%', 'z-index': '999999', 'top': '29px' });
        $('.sd_product-search').fadeIn('fast');
        $('.sd_fixinner .sd_pro-search').css({ 'font-family': 'arial', 'height': '38px', 'margin': '0', 'padding': '5px', 'max-width': '100%', 'background': '#fff' });

        if ($(window).width() < 767) {
            $('.sd_fixinner .sd_product-search').css({ 'margin': '0', 'max-width': '100%', 'font-family': 'arial', 'height': '38px', 'width': '88%', 'position': 'relative' });
        }
        else {
            $('.sd_fixinner .sd_product-search').css({ 'margin': '0', 'max-width': '100%', 'font-family': 'arial', 'height': '38px', 'width': '90%', 'position': 'relative' });
        }

        // fixed search start here
        $(".sd_pro-search").keyup(function (e) {
            $('.sd_dropdown').show();
            // setTimeout(removeLoader, 2000);
            var textLength = $(this).val().length;
            var mysearchval = $(this).val();
            if (textLength > 1) {
                // $('.sd_product-search').append('<div style="" id="loadingDiv" class="loadingDiv"><div class="loaderfix" style="background:none;"><img src="https://shinedezign.tk/p/images/Rollingloader.gif" /></div></div>');
                var searchval = $(this).val();
                var searchstring = searchval.toUpperCase();
                var hostname = window.location.hostname;
                var proarray = null;
                jQuery.getJSON("/search/suggest.json", {
                    "q": searchval,
                    "resources": {
                        "type": "product,page,article,collection",
                        "options": {
                            "unavailable_products": out_stock,
                            "fields": "title,variants.title"
                        }
                    }
                }).done(function (response) {

                    // console.log(response);
                    // $(".loadingDiv").hide();
                    if (product == '' && collection == '' && page == '' && article == '') {
                        $('.sd_dropdown').html('<div class="sd_tab"><button class="tablinks1">Products</button><button class="tablinks2">Collection</button><button class="tablinks3">Pages</button><button class="tablinks4">Articles</button></div><div class="sd_tabs"></div>');
                    }
                    else {
                        var tab_html = '<div class="sd_tab">';
                        if (product == 'yes' || product == '') {
                            tab_html = tab_html + '<button class="tablinks1">Products</button>';
                        }
                        if (collection == 'yes' || collection == '') {
                            tab_html = tab_html + '<button class="tablinks2">Collection</button>';
                        }
                        if (page == 'yes' || page == '') {
                            tab_html = tab_html + '<button class="tablinks3">Pages</button>';
                        }
                        if (article == 'yes' || article == '') {
                            tab_html = tab_html + '<button class="tablinks4">Articles</button>';
                        }
                        tab_html = tab_html + '</div><div class="sd_tabs"></div>';
                        $('.sd_dropdown').html(tab_html);
                    }
                    // $('.sd_dropdown').html('<div class="sd_tab"><button class="tablinks1 active">Products</button><button class="tablinks2">Collection</button><button class="tablinks3">Pages</button><div class="sd_tabs"></div></div>');
                    var rex = /(<([^>]+)>)/ig;
                    var proarray = [];
                    var data = response.resources.results;
                    if (data.articles.length > 0) {
                        var pageSuggestions = data.articles;
                        var proarray2 = [];
                        var appendToResult3 = '<div class="pagelist"><ul class="sd_dropdownresult_page">';
                        $.each(data.articles, function (index, articles) {
                            var prodvals = articles.title;
                            var prods = prodvals.toUpperCase();
                            if (prods.indexOf(searchstring) >= 0) {
                                //if (prod.indexOf(searchstring) == -1) {
                                appendToResult3 = appendToResult3.concat('<li id="' + articles.id + '"><a href="' + articles.url + '"><div class="sd_span"><div class="sd_title"> &#9679; ' + articles.title + '</div></div></a></li>');
                                proarray2.push({
                                    pid: articles.id,
                                    ptitel: articles.title,
                                    phandle: articles.handle
                                });
                            }
                        });
                        var proarry2 = JSON.stringify(proarray2);
                        appendToResult3 = appendToResult3.concat('</ul><div class="sd_more_result"><span class="sd_show_all"><a class="showproduct" href="https://' + hostname + '/search?article=1&q=' + encodeURIComponent(searchval) + '&type=article">' + footer_boxtext + '</a></span></div></div>');
                        // $('.sd_tabs').html(appendToResult2);
                        $(".tablinks4").click(function (e) {
                            e.preventDefault();
                            $(".tablinks4").addClass("active");
                            $(".tablinks2").removeClass("active");
                            $(".tablinks3").removeClass("active");
                            $(".tablinks1").removeClass("active");
                            $('.sd_tabs').html(appendToResult3);
                            page_highlight(mysearchval);
                        });
                    }
                    else {
                        $(".tablinks4").click(function (e) {
                            e.preventDefault();
                            $('.sd_tabs').html('</ul><div class="sd_more_result"><span class="sd_show_all noresult">' + footer_noresult + '</span></div></div>');
                            $(".tablinks4").addClass("active");
                            $(".tablinks3").removeClass("active");
                            $(".tablinks2").removeClass("active");
                            $(".tablinks1").removeClass("active");
                        });
                    }
                    if (data.pages.length > 0) {

                        var pageSuggestions = data.pages;
                        var proarray2 = [];
                        var appendToResult2 = '<div class="pagelist"><ul class="sd_dropdownresult_page"><li class=""></li>';
                        $.each(data.pages, function (index, pages) {
                            var prodvals = pages.title;
                            var prods = prodvals.toUpperCase();
                            if (prods.indexOf(searchstring) >= 0) {
                                //if (prod.indexOf(searchstring) == -1) {
                                appendToResult2 = appendToResult2.concat('<li id="' + pages.id + '"><a href="https://' + hostname + '/pages/' + pages.handle + '"><div class="sd_span"><div class="sd_title"> &#9679; ' + pages.title + '</div></div></a></li>');
                                proarray2.push({
                                    pid: pages.id,
                                    ptitel: pages.title,
                                    phandle: pages.handle
                                });

                            }
                        });

                        var proarry2 = JSON.stringify(proarray2);
                        appendToResult2 = appendToResult2.concat('</ul><div class="sd_more_result"><span class="sd_show_all"><a class="showproduct" href="https://' + hostname + '/search?page=1&q=' + encodeURIComponent(searchval) + '&type=page">' + footer_boxtext + '</a></span></div></div>');
                        $(".tablinks3").click(function (e) {
                            $('.tablinks3').addClass("active");
                            $('.tablinks2').removeClass("active");
                            $('.tablinks1').removeClass("active");
                            $('.tablinks4').removeClass("active");
                            $('.sd_tabs').html(appendToResult2);
                            page_highlight(mysearchval);
                        });
                    }
                    else {
                        $(".tablinks3").click(function (e) {
                            $('.tablinks3').addClass("active");
                            $('.tablinks2').removeClass("active");
                            $('.tablinks1').removeClass("active");
                            $('.tablinks4').removeClass("active");
                            $('.sd_tabs').html('</ul><div class="sd_more_result"><span class="sd_show_all noresult">' + footer_noresult + '</span></div></div>');
                        });
                    }

                    if (data.collections.length > 0) {
                        var collectionSuggestions = data.collections;
                        var proarray1 = [];
                        var appendToResult1 = '<div class="collectionpanel"><ul class="sd_dropdownresult_collection"><li class=""></li>';
                        $.each(data.collections, function (index, collections) {
                            var prodvals = collections.title;
                            var prods = prodvals.toUpperCase();
                            if (prods.indexOf(searchstring) >= 0) {
                                //if (prod.indexOf(searchstring) == -1) {
                                appendToResult1 = appendToResult1.concat('<li id="' + collections.id + '"><a href="https://' + hostname + '/collections/' + collections.handle + '"><div class="sd_span"><div class="sd_title"> &#9679; ' + collections.title + '</div></div></a></li>');
                                proarray1.push({
                                    pid: collections.id,
                                    ptitel: collections.title,
                                    phandle: collections.handle
                                });
                            }
                        });

                        var proarry1 = JSON.stringify(proarray1);
                        appendToResult1 = appendToResult1.concat('</ul><div class="sd_more_result"><span class="sd_show_all"><a class="showproduct" href="https://' + hostname + '/collections">View All Collections</a></span></div></div>');
                        if (proarray1.length > 0) {
                            $(".tablinks2").click(function (e) {
                                $('.tablinks2').addClass("active");
                                $('.tablinks1').removeClass("active");
                                $('.tablinks3').removeClass("active");
                                $('.tablinks4').removeClass("active");
                                $('.sd_tabs').html(appendToResult1);
                                col_highlight(mysearchval);
                            });
                        }
                    }
                    else {

                        $(".tablinks2").click(function (e) {
                            $('.tablinks2').addClass("active");
                            $('.tablinks1').removeClass("active");
                            $('.tablinks3').removeClass("active");
                            $('.tablinks4').removeClass("active");
                            $('.sd_tabs').html('</ul><div class="sd_more_result"><span class="sd_show_all noresult">' + footer_noresult + '</span></div></div>');
                        });
                    }

                    if (data.products.length > 0) {
                        var appendToResult = '<ul class="sd_dropdownresult"><li class=""></li>';
                        $.each(data.products, function (index, products) {
                            var prodval = products.title;
                            var productSuggestions = response.resources.results.products;
                            var productsuggest = productSuggestions[index];
                            console.log(productsuggest)
                            var prod = prodval.toUpperCase();
                            if (productsuggest.image != null) {
                                var imagesrc = '<div class="sd_searchimage"><img class="prdimg" width="50px" src="' + productsuggest.image + '"></div>';
                            }
                            else {
                                var imagesrc = '<div class="sd_searchimage"><img class="sd_noimg prdimg" width="50px" src="https://storage.googleapis.com/binderpos-libraries/NoPicAvailable.png" />';
                            }
                            //if (prod.indexOf(searchstring) == -1) {
                            appendToResult = appendToResult.concat('<li id="' + products.id + '"><a href="https://' + hostname + '/products/' + products.handle + '">' + imagesrc + '</div><div class="sd_span"><div class="sd_title">' + products.title + '</div><div class="sd_price binder_predictiveSearch_price" style=color:' + prccolor + '!important;>' + (productsuggest.price_max > productsuggest.price ? (Shopify.formatMoney((productsuggest.price_min), window.theme.moneyWithCurrencyFormat) + " - " + Shopify.formatMoney((productsuggest.price_max), window.theme.moneyWithCurrencyFormat)) : Shopify.formatMoney((productsuggest.price), window.theme.moneyWithCurrencyFormat)) + '</div></div></a></li>');
                            proarray.push({
                                pid: products.id,
                                ptitel: products.title,
                                phandle: products.handle
                            });

                        });
                        appendToResult = appendToResult.concat('</ul><div class="sd_more_result"><span class="sd_show_all"><a class="showproduct" href="https://' + hostname + '/search?page=1&q=' + encodeURIComponent(searchval) + '&type=product">' + footer_boxtext + '</a></span></div></div>');
                        if (proarray.length > 0) {
                            $('.sd_tabs').html(appendToResult);
                            $('.tablinks1').addClass("active");
                        }

                        $(".tablinks1").click(function (e) {
                            $('.tablinks1').addClass("active");
                            $('.tablinks2').removeClass("active");
                            $('.tablinks3').removeClass("active");
                            $('.tablinks4').removeClass("active");
                            $('.sd_tabs').html(appendToResult);
                            //highlight(mysearchval);
                        });
                        var proarry = JSON.stringify(proarray);
                        //highlight(mysearchval);
                    }
                    else {
                        $('.tablinks1').addClass("active");
                        $('.sd_tabs').html('</ul><div class="sd_more_result"><span class="sd_show_all noresult">' + footer_noresult + '</span></div></div>');
                        $(".tablinks1").click(function (e) {
                            $('.tablinks1').addClass("active");
                            $('.tablinks2').removeClass("active");
                            $('.tablinks3').removeClass("active");
                            $('.tablinks4').removeClass("active");
                            $('.sd_tabs').html('</ul><div class="sd_more_result"><span class="sd_show_all noresult">' + footer_noresult + '</span></div></div>');
                        });
                    }
                });
            }
            else {
                $('.sd_dropdown').html(' ');
            }
            setTimeout(function () {
                //highlight(mysearchval);
            }, 600);
        });
    });

    $(document).on('mouseenter', '.sd_dropdownresult li a', function () {
        $(this).css({ 'background': 'rgb(242,242,242)' });
    });
    $(document).on('mouseleave', '.sd_dropdownresult li a', function () {
        $(this).css({ 'background': '#fff' });
    });
    $(document).on('mouseenter', '.sd_dropdownresult_collection li a', function () {
        $(this).css({ 'background': 'rgb(242,242,242)' });
    });
    $(document).on('mouseleave', '.sd_dropdownresult_collection li a', function () {
        $(this).css({ 'background': '#fff' });
    });

})();